<template>
    <div class="container mt-5">
      <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
      <nav class="level is-mobile">
						<div class="level-left">
                            <div class="level-item" v-if="dateLoadedImagesOfMonth">
                              <b-field label="Month-Year">
                               <span class="is-size-5 has-text-primary">{{monthYearLoaded}}</span> 
                              </b-field> 
                            </div>  
                            <div class="level-item" >
                               &nbsp;
                            </div>  
                            <div class="level-item" v-if="dateLoadedImagesOfMonth">
                              <b-field label="จำนวนรูป">
                               <span class="is-size-5 has-text-primary">{{arrImagesOfMonth.length}}</span> 
                              </b-field> 
                            </div>  


						</div>
						<div class="level-right">
							<div class="level-item">
  <b-field label="Select a month">
                                        <b-datepicker
                                           v-model="dateWantToSeeImagesOfMonthModel"
                                            type="month"
                                            placeholder="Click to select..."
                                            icon="calendar-today"
                                            trap-focus>
                                        </b-datepicker>
                                    </b-field>
							</div>
                            <div class="level-item">
                                  <b-field label="#">
                                      <template #label>
                                        <span class="has-text-white">#</span>   
                                      </template>
                                    <b-button type="is-success is-light"
                                     @click="reload"
                                    >Reload</b-button>
                                  </b-field>
                            </div>    
						</div>
					</nav>
<!-- paginated
                        :per-page="perPage"
                        :current-page.sync="currentPage"
                         -->
            <section class="container">
                    <input class="input" type="text" v-model="filterWord" 
                                       placeholder="Filter for OPD No., Pet Name , Pathologist , DX" 
                                    >  
                <b-table
                        :data="isEmpty ? [] : arrImagesOfMonthFilter"
                         
                          paginated
                          :per-page="perPage"
                          :current-page.sync="currentPage"
                     
                     
                        mobile-cards 
                     
            
            > 
            
         

                        <b-table-column  label="Images"   v-slot="props">
                            <!-- {{ props.row.idlab }} -->
                               <article class="media">
                                    <figure class="media-left" @click="imageModal( rebuildImage({'path':props.row.path ,'idlab':props.row.idlab }) )" >
                                        <p class="image is-128x128">
                                            <img :src="rebuildImage({'path':props.row.path ,'idlab':props.row.idlab })"  style="cursor: pointer;">
                                        </p>
                                    </figure>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="has-text-grey-darker">
                                                <strong class="mr-5"> Lab ID : 
                                                    
                                                    <!-- <span class="has-text-info">{{ props.row.idlab }}</span>  -->
                                                    <b-button type="is-success" outlined @click="showLab({idlab:props.row.idlab , kind : props.row.kind , idopd : props.row.opd_no })"> {{ props.row.idlab }}</b-button>    
                                                    <b-tooltip label="Copy to clipboard">
                                                        <b-button  
                                                            v-clipboard:copy="props.row.idlab"
                                                            @click="clickCopyIntoClipboard(props.row.idlab)"
                                                            icon-left="content-copy" />
                                                    </b-tooltip>
                                                </strong>
                                                <small  class="mr-5">  OPD No. : <span  class="has-text-info"><text-highlight :queries="queries"> {{ props.row.opd_no }} </text-highlight> </span>   </small>
                                                <small  class="mr-5">  Pet Name : <span  class="has-text-info" ><text-highlight :queries="queries">{{ props.row.pet_name }} </text-highlight> </span>   </small>
                                                <small  class="mr-5">  Gender : <span  class="has-text-info" >{{ props.row.pet_gender }}</span>   </small>
                                                <small  class="mr-5">  Age : <span  class="has-text-info" >{{ props.row.age_ymd }}</span>   </small>
                                                <small  class="mr-5">  Breed : <span  class="has-text-info" >{{ props.row.breed }}</span>   </small>
                                                <small  class="mr-5">  Species : <span  class="has-text-info" >{{ props.row.species }}</span>   </small>
                                            </p>
                                            
                                        </div>

                                        <div class="content">
                                            <p class="has-text-grey-darker">
                                                <strong class="mr-5"> Pathologist: <span class="has-text-info"><text-highlight :queries="queries">{{ props.row.assign_to_user }}</text-highlight></span> </strong>
                                                <small  class="mr-5">  Date/Time Record : 
                                                    <span  class="has-text-info mr-2">{{ getDateFromISODT(props.row.dt_rec)}}</span>   
                                                    <span  class="has-text-info is-size-7 is-italic">({{ getTimeFromISODT(props.row.dt_rec)}})</span>   
                                                    </small>
                                                <small  class="mr-5">  Record By : <span  class="has-text-info" >{{ props.row.user_rec }}</span>   </small>    
                                            </p>
                                        </div>
                                  
                                     <table class="table mb-5 is-fullwidth is-size-7 is-bordered" v-if="props.row.dx.length>0" >
                                                <thead>
                                                    <tr>
                                                    <th width="25%"> Unclassified codes </th>
                                                    <th width="25%"> Remark </th>
                                                    <th width="50%"> Dx </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="dx in props.row.dx" :key="dx.uuid">
                                                        <td><text-highlight :queries="queries">{{dx.unclassified_codes }}</text-highlight></td>
                                                        <td><text-highlight :queries="queries">{{dx.comment_txt  }}</text-highlight></td>
                                                        <td><text-highlight :queries="queries">{{dx.dx_code  }}</text-highlight></td>
                                                    </tr>
                                                </tbody>

                                     </table>  
                                    </div>
                                </article>
                        </b-table-column>



                        <template slot="footer"  >
                                        <div class="box">
                                            <div  class="level-right" >    <b-button type="is-primary" outlined 
                                                v-show="arrImagesOfMonth.length>0"    
                                                :disabled="isMoreBtnLoading" 
                                                :loading="isMoreBtnLoading" 
                                                @click="loadDataMore" >More..</b-button></div>
                                        </div>
                        </template>


                </b-table>        
            </section>
    
        <b-modal :active.sync="isImageModalActive">
            <p class="image ">
                <img :src=dataUrl>
            </p>
        </b-modal>
    </div>
</template>


<script>
import { mapActions, mapMutations, mapState } from "vuex";
import axios from "axios";
import { getBaseURLAvartar , myTimeZone , getBaseURLforBackEnd  , getConfigAxios ,} from '@/utils.js'
import getDecodeFromBase64ToHtml from '../../mixins/methods/getDecodeFromBase64ToHtml'
import moment from 'moment-timezone' 

export default {
    name : "ImagesOfMonth",
    mixins:[getDecodeFromBase64ToHtml,],
    mounted(){
        console.log("mount")
        if(this.arrImagesOfMonth.length ===0){
           this.reload() 
           console.log("reload cause mount")
        }
    },
    computed:{
            ...mapState({
                user_id : state => state.master_data.user_id ,
                clientIP : state => state.master_data.clientIP ,
                dateWantToSeeImagesOfMonth : state => state.images_of_month.dateWantToSeeImagesOfMonth,
                dateLoadedImagesOfMonth : state => state.images_of_month.dateLoadedImagesOfMonth,
                arrImagesOfMonth :state => state.images_of_month.arrImagesOfMonth,
                firstImagesOfMonth: state => state.images_of_month.firstImagesOfMonth,
                skipImagesOfMonth: state => state.images_of_month.skipImagesOfMonth,
            }) ,

            dateWantToSeeImagesOfMonthModel:{
                get: function () {
                    return this.dateWantToSeeImagesOfMonth
                },
                set: function (newValue) {
                    this.setDateWantToSeeImagesOfMonth(newValue)
                }
            },

            // arrImagesOfMonthWithDecode(){

            //     return this.arrImagesOfMonth.map(dat=>{
            //         dat.dx.forEach(datDx=>{
            //             // console.log('datDx --->',datDx.comment_txt);
            //             //  console.log('datDx.comment_txt--->',datDx.comment_txt);
            //              datDx.comment_txt= datDx.comment_txt  ? this.getDecodeFromBase64ToHtml(datDx.comment_txt) : null
            //              datDx.unclassified_codes= datDx.unclassified_codes  ? this.getDecodeFromBase64ToHtml(datDx.unclassified_codes) : null
            //              datDx.dx_code= datDx.dx_code  ? this.getDecodeFromBase64ToHtml(datDx.dx_code) : null
            //         })   
            //         return dat
            //     })
            // },

            monthYearLoaded(){
                return   moment(  this.dateLoadedImagesOfMonth , myTimeZone  ).format("MM-YYYY")   
            },
            arrImagesOfMonthFilter(){
                   return this.arrImagesOfMonth.filter(dat=>{
                                  
                                  
                                  if(dat.dx.length>0){
                                      const tmp = dat.dx.filter(datDx=>{
                                         return ( datDx.comment_txt!==null && datDx.comment_txt.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1 ) ||
                                                ( datDx.unclassified_codes!==null && datDx.unclassified_codes.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1 ) ||
                                                ( datDx.dx_code!==null && datDx.dx_code.toUpperCase().indexOf(this.filterWord.toUpperCase()) > -1 ) 
                                      })
                                      


                                     if(tmp.length>0){
                                        return dat
                                     }else{
                                       return dat.opd_no.indexOf(this.filterWord) > -1  || 
                                              dat.pet_name.indexOf(this.filterWord) > -1 || 
                                              dat.assign_to_user.indexOf(this.filterWord) > -1
                                     }





                                    }else{
                                       return dat.opd_no.indexOf(this.filterWord) > -1   ||
                                              dat.pet_name.indexOf(this.filterWord) > -1  || 
                                              dat.assign_to_user.indexOf(this.filterWord) > -1
                                    }
                                    
  

                               })  
            },
            queries(){
                return this.filterWord.split(" ");
            }


            
    },
    methods:{
        ...mapMutations({
             setDateWantToSeeImagesOfMonth: 'images_of_month/setDateWantToSeeImagesOfMonth',  
             setSkipImagesOfMonth: 'images_of_month/setSkipImagesOfMonth', 
             setArrImagesOfMonthToZero: 'images_of_month/setArrImagesOfMonthToZero', 
        }),
        ...mapActions({
             fetchArrImagesOfMonth: 'images_of_month/fetchArrImagesOfMonth',  
             setupIDOPDTarget : 'opd_target/setupIDOPDTarget',
             produceSetCounterTest: 'master_data/produceSetCounterTest',
             setupIDLABTarget : 'lab_target/setupIDLABTarget',
        }),
        imageModal(dataUrl){
          if(dataUrl !== "") {
                    this.dataUrl = dataUrl
                }else{
                    this.dataUrl = 'imgnotaval.jpg'
                }
                this.isImageModalActive = true

        },
        clickCopyIntoClipboard(_id){
              this.$buefy.toast.open({
                    duration: 2000,
                    message: `Copy <b>${_id}</b> to clipboard`,
                    position: 'is-bottom',
                    type: 'is-primary is-light'
                })
        }, 
        async  showLab(payload){
           // payload ={"idlab":idlab , "kind" : kind , "idopd" : idopd }
            if(this.user_id !== null) {

                        const tmpcounterTest = 1
                        this.produceSetCounterTest(tmpcounterTest)


                        const datTo = {
                            "idopd": payload.idopd,
                            "user": this.user_id,
                            "ip": this.clientIP
                        }
                        const vm = this

                        await axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn`, datTo, getConfigAxios())
                            .then(res => {
                                    // console.log('res ---->',res) 
                                    vm.OPDSelected = {
                                        "idopd": res.data.idopd,
                                        "idlab": "",
                                        "opdname": res.data.name,
                                        "type": res.data.species + '(' + res.data.breed + ')',
                                        "owner_name": res.data.owner_name,
                                        "status": "",
                                        "gender": res.data.sex,
                                        "age": res.data.age,
                                        "kind": "",
                                        "automate": "",
                                        "datereq": "",
                                        "timereq": "",
                                        "reqby": "",
                                        "dateaccept": "",
                                        "timeaccept": "",
                                        "acceptby": "",
                                        "datecancle": "",
                                        "timecancle": "",
                                        "cancleby": "",
                                        "datereject": "",
                                        "timereject": "",
                                        "rejectby": "",
                                        "dateresult": "",
                                        "timeresult": "",
                                        "resultby": ""
                                    }
                                    vm.setupIDOPDTarget(vm.OPDSelected)
                                    .then(()=>{
                                        // console.log('payload.kind--->  ',payload.kind)
                                        vm.setupIDLABTarget({"idlab": payload.idlab, "kind": payload.kind})
                                            .then(()=>{
                                                vm.$router.push('/worklist',()=>{
                                                       console.log('push /worklist')
                                                })
                                                    .catch(()=>{});

                                            })
                                    })


                                }
                            )
                            .catch((err) => {
                                if (err.response && err.response.status === 401) {
                                    vm.$router.push('/login')
                                }
                            })
                            .finally(() => {

                            })


            }else{
                this.$router.push('/login')
                    .catch(()=>{});
            }


      },
       
        getTimeFromISODT(dat){
            //  time_start :    ( (dat.datetime_start.split("T")[1]).split(":") ) [0] + ':' + ( (dat.datetime_start.split("T")[1]).split(":") ) [1] ,
            const tmpTime= dat.split("T")[1]
            return `${tmpTime.split(":")[0]}:${tmpTime.split(":")[1]} `
        },
        getDateFromISODT(dat){
            //  time_start :    ( (dat.datetime_start.split("T")[1]).split(":") ) [0] + ':' + ( (dat.datetime_start.split("T")[1]).split(":") ) [1] ,
            return dat.split("T")[0]
        },

        loadDataMore(){
            const tmp = this.skipImagesOfMonth+this.firstImagesOfMonth
            this.isMoreBtnLoading = true
            this.setSkipImagesOfMonth(tmp)
            this.fetchArrImagesOfMonth()
                 .then((res)=>{
                    this.isMoreBtnLoading = false

                    
                    if(res.length==0){
                      this.$buefy.snackbar.open({
                            duration: 3000,
                            message: `no more data to load anymore`,
                            type: 'is-warning',
                            position: 'is-top',
                            queue: false,
                        }) 
                    }else{
                        this.$buefy.snackbar.open({
                            duration: 3000,
                            message: `Load Completed`,
                            type: 'is-danger',
                            position: 'is-bottom-left',
                            queue: false,
                            })  
                        // console.log(this.currentPage)    
                        this.currentPage =   Math.floor( this.arrImagesOfMonthFilter.length / this.perPage )

                    }
                    

                 })
                 .catch(()=>{
                    this.isMoreBtnLoading = false
                 })
        },
        reload(){
             this.isFullScreenSearching = true
             this.setSkipImagesOfMonth(0)
             this.setArrImagesOfMonthToZero([])


             this.fetchArrImagesOfMonth()
                 .then(()=>{
                    this.isFullScreenSearching = false
                    // this.currentPage = 1
                 })
                 .catch(()=>{
                    this.isFullScreenSearching = false
                    // this.currentPage = 1
                 })
        },
        rebuildImage(dat){
            return  `${getBaseURLAvartar()}/${dat.idlab}/${dat.path}`
        }
    },
    data(){
        return {
            isEmpty : false,
            isFullScreenSearching : false,

            perPage : 20,
            currentPage : 1,


            isMoreBtnLoading: false,
            filterWord : "",


            OPDSelected : {},

            isImageModalActive : false,
            dataUrl : ""
        }
    }       
}
</script>

<style scoped>
/* 
    img:hover{
        cursor: hand;
        cursor: pointer;
    } */

</style>

 